module.exports = __webpack_public_path__ + "static/media/tab_2.7298b948.png";